import { render, staticRenderFns } from "./item-checkbox.vue?vue&type=template&id=4203d6c1&scoped=true"
import script from "./item-checkbox.vue?vue&type=script&setup=true&lang=js"
export * from "./item-checkbox.vue?vue&type=script&setup=true&lang=js"
import style0 from "./item-checkbox.vue?vue&type=style&index=0&id=4203d6c1&prod&lang=less&scoped=true"
import style1 from "./item-checkbox.vue?vue&type=style&index=1&id=4203d6c1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4203d6c1",
  null
  
)

export default component.exports